import React from "react";
import "./../icon_for_notifs.css";

const FeatureBox = () => {
    return (
        <div className="icon">
            {" "}
            { }
            <div className="icon_design">
                <p>
                    <strong>
                        Upcoming expo plan for <span>#csit</span>
                    </strong>
                </p>
                <p>
                    <em>2024-SEP-20</em>
                </p>
                <button className="join-button">JOIN</button>
            </div>
        </div>
    );
};

export default FeatureBox;
